import { useState } from "react"
import { Accordion, AccordionDetails, AccordionSummary, IconButton, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { DetailColumn } from "./detail-column"

export function RuleDetailsAccordion({ defaultAction, regime, assetRegister, onEdit }) {
    const [expanded, setExpanded] = useState(false)

    return (
        <Accordion
            data-cy="rule-details-accordion"
            expanded={expanded}
            onChange={handleToggle}
            disableGutters
            elevation={0}
            square
            sx={{
                border: "none",
                bgcolor: "transparent",
                boxShadow: "none !important",
                "&:before": { display: "none" },
                "&.Mui-expanded": { boxShadow: "none !important", borderRadius: 0, margin: 0 },
            }}
        >
            <AccordionSummary
                expandIcon={<Iconify icon="mingcute:down-line" width={24} />}
                sx={{
                    pl: 0,
                    pr: 1.5,
                    py: 1.5,
                    minHeight: 0,
                    "& .MuiAccordionSummary-content": { my: 0, gap: 2, alignItems: "center" },
                }}
            >
                <Typography sx={{ flex: 1, fontSize: 18, fontWeight: 600, lineHeight: "28px" }}>
                    Rule Details
                </Typography>
                <If value={onEdit}>
                    <IconButton
                        aria-label="Edit rule details"
                        onClick={handleEditClick}
                        data-cy="edit-rule-details"
                        sx={{ p: 0.5, mr: 1 }}
                    >
                        <Iconify icon="solar:pen-bold" width={20} />
                    </IconButton>
                </If>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0, pt: 2, pb: 3 }}>
                <Stack direction="row" spacing={10} sx={{ width: 1 }}>
                    <DetailColumn label="Default Action" value={formatDefaultAction(defaultAction)} />
                    <DetailColumn label="Regime" value={regime?.label || "-"} />
                    <DetailColumn label="Asset Register" value={assetRegister?.label || "-"} />
                </Stack>
            </AccordionDetails>
        </Accordion>
    )

    function handleToggle(_, isExpanded) {
        setExpanded(isExpanded)
    }

    function handleEditClick(e) {
        e.stopPropagation()
        onEdit?.()
    }
}

function formatDefaultAction(defaultAction) {
    return defaultAction === "exclude" ? "All Tasks Excluded" : "All Tasks Included"
}
